<template>
  <DefaultTemplate positionNavNextTo="right" type="signup">
    <div v-loading="loading" class="box-container pd-y-1">
      <Header
        title="เข้าสู่ระบบเรียนออนไลน์"
        :showSigninWith="true"
        @signIn="signIn"
      />

      <div class="flex-display js-center ai-center pd-y-3">
        <div class="border-t border-color-primary border-semi-bold width-100" />
        <div class="width-word-or">
          <h5 class="color-primary text-font-18 pd-x-4 mg-less">หรือ</h5>
        </div>
        <div class="border-t border-color-primary border-semi-bold width-100" />
      </div>
      <el-form
        label-position="top"
        :model="formSignin"
        :rules="rules"
        ref="formSignin"
        class="text-left"
      >
        <el-row :gutter="30">
          <el-col :span="24">
            <div class="pd-b-4">
              <el-alert
                v-if="msgErrorValid !== ''"
                title="แจ้งเตือน"
                type="error"
                @close="msgErrorValid = ''"
                :description="msgErrorValid"
                :class="{ 'shake animated': animated }"
              ></el-alert>
            </div>
          </el-col>
          <el-col :span="24">
            <el-form-item label="อีเมล" prop="email" class="text-font-18">
              <el-input
                v-model="formSignin.email"
                @keyup.enter.native="checkValidSignin"
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="24">
            <el-form-item label="รหัสผ่าน" prop="password" class="text-font-18">
              <el-input
                v-model="formSignin.password"
                :type="hidePass ? 'password' : ''"
                autocomplete="off"
                @keyup.enter.native="checkValidSignin"
              >
                <span slot="suffix">
                  <i
                    v-if="hidePass"
                    @click="hidePass = false"
                    class="cursor-pointer fas fa-eye mg-r-5"
                  ></i>
                  <i
                    v-else
                    @click="hidePass = true"
                    class="cursor-pointer fas fa-eye-slash mg-r-5"
                  ></i>
                </span>
              </el-input>
            </el-form-item>
            <div class="text-right">
              <a
                @click="$router.push('/forgot/password')"
                class="text-font-14 color-secondary"
                >ลืมรหัสผ่าน?</a
              >
            </div>
          </el-col>
          <el-col :span="24" class="pd-t-3">
            <el-button
              @click="checkValidSignin"
              type="primary"
              class="width-100 text-font-18 button-auth"
              round
              >เข้าสู่ระบบ</el-button
            >
          </el-col>
        </el-row>
      </el-form>
    </div>
  </DefaultTemplate>
</template>

<script>
import DefaultTemplate from "@/template/DefaultTemplate";
import Header from "@/components/template/Header";
import { HTTP } from "@/service/axios.js";

export default {
  components: {
    DefaultTemplate,
    Header,
  },
  computed: {
    token() {
      return this.$store.state.token;
    },
    user() {
      return this.$store.state.user;
    },
  },
  data() {
    return {
      loading: false,
      formSignin: {
        email: "",
        password: "",
      },
      rules: {
        email: [
          {
            required: true,
            message: "กรุณากรอกอีเมล",
            trigger: "blur",
          },
          {
            type: "email",
            message: "กรุณากรอกอีเมลให้ถูกต้อง",
            trigger: "blur",
          },
        ],
        password: [
          { required: true, message: "กรุณากรอกรหัสผ่าน", trigger: "blur" },
        ],
      },
      animated: true,
      msgErrorValid: "",
      hidePass: true,
      courseStatus: 0,
      courseId: "",
    };
  },
  mounted() {
    this.fetchCourse();
  },
  methods: {
    fetchCourse() {
      HTTP.get(`list/course/0/0/all`).then((res) => {
        if (res.data.success) {
          this.courseId = res.data.obj[0]._id;
        }
      });
    },
    checkValidSignin() {
      this.$refs["formSignin"].validate((valid) => {
        if (valid) {
          this.signIn(this.formSignin.email, this.formSignin.password);
        }
      });
    },
    signIn(email, password, from) {
      this.loading = true;

      let obj = {
        email: email,
        password: password,
      };

      HTTP.post(`sign/in`, obj)
        .then(async (res) => {
          this.msgErrorValid = "";
          if (res.data.success) {
            this.$store.commit("SET_TOKEN", res.data.obj.token);
            let user = {
              email: res.data.obj.email,
              profileImg: res.data.obj.profileImg,
              profileFrom: res.data.obj.profileFrom,
              role: res.data.obj.role,
              userId: res.data.obj.userId,
              titleName: res.data.obj.titleName,
              nameTH: res.data.obj.nameTH,
              surnameTH: res.data.obj.surnameTH,
              from: res.data.obj.from,
            };

            this.$store.commit("SET_USER", user);
            if (res.data.obj.role == 0) {
              await this.fetchCourseStatus();
              this.fetchStudentsById(res.data.obj.userId);
            } else if (res.data.obj.role == 50) {
              setTimeout(() => {
                this.$router.push("/manage/course/instructor");
              }, 500);
            } else {
              setTimeout(() => {
                this.$router.push("/manage/course/list");
              }, 500);
            }
          } else {
            if (res.data.data == "wrong email or password.") {
              setTimeout(() => {
                this.msgErrorValid = "อีเมลหรือรหัสผ่านไม่ถูกต้อง";
              }, 50);
            } else {
              this.alertFailError();
            }
          }
        })
        .catch((e) => {
          this.alertCatchError(e);
          console.log("signIn error", e);
        })
        .finally(() => {
          setTimeout(() => {
            this.loading = false;
          }, 500);
        });
    },
    fetchStudentsById(userId) {
      let obj = {
        _id: userId,
      };

      HTTP.defaults.headers.common.Authorization = `Bearer ${this.token}`;
      HTTP.post(`get/student`, obj)
        .then((res) => {
          if (res.data.success) {
            if (res.data.obj.nameEN && res.data.obj.institution.name) {
              this.$store.commit("SET_HAVE_USER_DATA", true);
              if (this.courseStatus == 0 && this.courseId) {
                this.$router.push(`/course/detail?courseId=${this.courseId}`);
              } else {
                this.$router.push("/my/course?tab=1");
              }
            } else {
              this.$store.commit("SET_HAVE_USER_DATA", false);
              this.$router.push("/profile");
            }
          } else {
            this.alertFailError();
          }
        })
        .catch((e) => {
          this.alertCatchError(e);
          console.log("fetchStudentsById error", e);
        });
    },
    fetchCourseStatus() {
      let obj = {
        _id: this.user.userId,
      };

      HTTP.defaults.headers.common.Authorization = `Bearer ${this.token}`;
      HTTP.post(`status/course`, obj).then((res) => {
        if (res.data.success) {
          let pending = res.data.obj.pending.filter(
            (filter) => filter.courseId == this.courseId
          );

          let approved = res.data.obj.approved.filter(
            (filter) => filter.courseId == this.courseId
          );

          let disapproval = res.data.obj.disapproval.filter(
            (filter) => filter.courseId == this.courseId
          );

          if (pending.length > 0) {
            this.courseStatus = 2;
          }

          if (approved.length > 0) {
            this.courseStatus = 1;
          }

          if (disapproval.length > 0) {
            this.courseStatus = 3;
          }
        }
      });
    },
  },
};
</script>

<style scoped></style>
